<template>
  <div v-if="isLoading" class="flex justify-center items-center p-4">
    <svg class="animate-spin mr-2 h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <span class="ml-2 text-slate-600 dark:text-slate-300">
      {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.LOADING_GROUP_SETTINGS') }}
    </span>
  </div>

  <div v-else class="mb-4 p-4 rounded-lg border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 transition-colors duration-200">
    <div class="flex justify-between items-start">
      <div class="mr-4">
        <h4 class="text-base text-slate-800 dark:text-slate-100 font-medium">
          {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.ACCEPT_GROUPS.TITLE') }}
        </h4>
        <p class="text-sm text-slate-600 dark:text-slate-300 mb-1">
          {{ $t('INBOX_MGMT.ADD.WHATAPPWEB.ACCEPT_GROUPS.DESCRIPTION') }}
        </p>
        
        <div class="h-5 mt-1">
          <span v-if="isSaving" class="text-xs text-blue-500 flex items-center">
            <svg class="animate-spin mr-1 h-3 w-3 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Guardando...
          </span>
          <span v-else-if="successMessage" class="text-xs text-green-600">
            {{ successMessage }}
          </span>
          <span v-else-if="errorMessage" class="text-xs text-red-600">
            {{ errorMessage }}
          </span>
        </div>

      </div>
      
      <label class="woot-switch-simulated">
        <input
          type="checkbox"
          v-model="acceptGroupConversations"
          @change="handleSettingChange"
          :disabled="isSaving"
        />
        <span class="slider round" :class="{ 'opacity-50': isSaving }"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inbox: {
      type: Object,
      required: true,
    },
  },

  data() {
    const initialValue = this.inbox.settings.accept_groups || false;
    return {
      acceptGroupConversations: initialValue,
      isSaving: false,
      isLoading: false,
      successMessage: '',
      errorMessage: '',
    };
  },

  watch: {
    'inbox.settings.accept_groups'(newValue) {
      if (newValue !== this.acceptGroupConversations && !this.isSaving) {
        this.acceptGroupConversations = newValue || false;
      }
    },
  },

  methods: {
    handleSettingChange() {
      const newValue = this.acceptGroupConversations;      
      this.$emit('update-group-preference', newValue);
    },

    setSaving(status) {
      this.isSaving = status;
      if (status) {
        this.errorMessage = '';
        this.successMessage = '';
      }
    },

    setSuccess() {
      this.successMessage = this.$t('INBOX_MGMT.ADD.WHATAPPWEB.ACCEPT_GROUPS.SUCCESS');
      this.isSaving = false;
      setTimeout(() => {
        this.successMessage = '';
      }, 3000);
    },

    setError(message) {
      this.errorMessage = message;
      this.isSaving = false;
      
      this.acceptGroupConversations = this.inbox.settings.accept_groups || false; 
      
      setTimeout(() => {
        this.errorMessage = '';
      }, 5000);
    },
  },
};
</script>

<style scoped>

.woot-switch-simulated {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 20px;
}

.woot-switch-simulated input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}

.slider.round {
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #3b82f6; /* Tailwind blue-500 */
}

input:focus + .slider {
  box-shadow: 0 0 1px #3b82f6;
}

input:checked + .slider:before {
  transform: translateX(18px); 
}
</style>
